<div class="avs-schema-station-container">
    <div class="m-2 border-bottom d-flex justify-content-between" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        <h5 class="fw-semibold">
            <span class="text-secondary">Station: </span>
            <button *canAccess="[1]" type="button" class="btn btn-outline-danger"
                (click)="onCloseAndNavigateToStation()">{{data.routeStation.name}}</button>
        </h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseBtnClicked()">
    </div>
    <div *ngIf="!showManualControls || (data.schemaInfo?.online && barrierControlFound)">
        <div class="p-2 mt-3 d-flex justify-content-around">
            <avs-project-route-station [routeStation]="data" [images]="projectImages" [isModalOpen]="true">
            </avs-project-route-station>
            <div>
                <div class="mb-5 d-flex justify-content-end flex-column ">
                    <button *canAccess="[1]"
                        class="btn btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onDeleteStationFromSchemaClicked()">
                        <span class="mb-auto">Station entfernen</span>
                        <img height="24" src="assets/icons/trash.svg" alt="delete station from schema" class="p-1 ms-2">
                    </button>

                    <button *ngIf="(data.schemaInfo?.solar?.data?.batteryVoltage ?? 0) > 0"
                        class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onShowEnergieDiagramFromSchemaClicked()">
                        <span class="mb-auto">Energiedaten</span>
                        <img height="24" src="assets/icons/bar-chart-fill.svg" alt="delete station from schema"
                            class="p-1 ms-2"></button>

                    <button *ngIf="(data.schemaInfo?.radars?.length ?? 0) > 0"
                        class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onShowSpeedChartFromSchemaClicked()">
                        <span class="mb-auto">Sensordaten</span>
                        <img height="24" src="assets/icons/bar-chart-fill.svg" alt="delete station from schema"
                            class="p-1 ms-2">
                    </button>

                    <div *canAccess="[1]">
                        <button *ngIf="(data.schemaInfo?.digitalIOs?.length ?? 0) > 0"
                            class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                            (click)="onShowSTMDiagramFromSchemaClicked()">
                            <span class="mb-auto">Digital IO Daten</span>
                            <img height="24" src="assets/icons/bar-chart-fill.svg" alt="delete station from schema"
                                class="p-1 ms-2">
                        </button>
                    </div>
                    <button *ngIf="(data.schemaInfo?.solar?.data?.batteryVoltage ?? 0) > 0"
                        class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onShowSolarDetailsFromSchemaClicked()">
                        <span class="mb-auto">Solardetails</span>
                        <img height="24" src="assets/icons/sun-fill.svg" alt="delete station from schema"
                            class="p-1 ms-2">
                    </button>
                    <button *ngIf="data.schemaInfo?.fuelcell?.data != null"
                        class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onShowBrennstoffzellenDetailsFromSchemaClicked()">
                        <span class="mb-auto">Brennstoffzelle</span>
                        <img height="24" src="assets/icons/gas_meter_24dp_5F6368_FILL0_wght400_GRAD0_opsz24_black.svg"
                            alt="delete station from schema" class="p-1 ms-2">
                    </button>
                    <button *ngIf="data.schemaInfo?.weather?.data != null"
                        class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onShowWeatherDataDetailsFromSchemaClicked()">
                        <span class="mb-auto">Wetterdetails</span>
                        <img height="24" src="assets/icons/weather/weather.svg" alt="delete station from schema"
                            class="p-1 ms-2">
                    </button>
                    <button *ngIf="data.schemaInfo?.weather?.data != null"
                        class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onShowWeatherDataVerlaufFromSchemaClicked()">
                        <span class="mb-auto">Wetterdaten</span>
                        <img height="24" src="assets/icons/bar-chart-fill.svg" alt="delete station from schema"
                            class="p-1 ms-2">
                    </button>

                    <!--  <button *ngIf="data.schemaInfo?.fuelcell?.data != null"
                        class="btn mt-1 btn-sm btn-outline-secondary rounded-0 shadow avs-schema-modal-btn d-flex justify-content-between"
                        (click)="onShowBrennstoffZellenVerlaufFromSchemaClicked()">
                        <span class="mb-auto">Brennstoffdaten</span>
                        <img height="24" src="assets/icons/bar-chart-fill.svg" alt="delete station from schema"
                            class="p-1 ms-2">
                    </button> -->
                    <!-- checkbox für steuerung default aus? -->


                </div>
            </div>
            <!--             <div
                *ngIf="data.schemaInfo?.online && data.schemaInfo?.deviceType !== 2 && data.schemaInfo?.deviceType !== 4">

            </div> -->
        </div>
    </div>
</div>
<div [matTooltip]="!data.schemaInfo?.online ? 'Steuerung ist nur bei online Geräten verfügbar' : ''">
    <mat-checkbox class="example-margin" [disabled]="!data.schemaInfo?.online" [(ngModel)]="showManualControls"> {{
        showManualControls ? 'Steuerung ausblenden' :
        'Steuerung einblenden' }}</mat-checkbox>
</div>

<div class="avs-manuel-control-container" *ngIf="showManualControls && data.schemaInfo?.online">
    <div *ngIf="aqControlFound" class="border-top mt-3 ms-2 me-2">
        <div class="d-flex  mt-3">

            <span class="fw-semibold text-secondary ms-2">Steuerung Anzeige </span>

            <span>
                <img *ngIf="!showAqControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-down.svg" alt="icon-delete-aq" (click)="onHideAQClick()"
                    matTooltip="Ausklappen" matTooltipPosition="right">
                <img *ngIf="showAqControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-up.svg" alt="icon-delete-aq" (click)="onHideAQClick()"
                    matTooltip="Einklappen" matTooltipPosition="right">
            </span>
            <span *ngIf="aqControlActive"> <img src="assets/icons/back_hand_material.svg" height="24"></span>

        </div>

        <div *ngIf="showAqControl && aqControlFound">
            <div class="mb-2 d-flex justify-content-center">
                <div>
                    <div [ngClass]="AQisKanalSelectOpen ? 'border-danger' : ''"
                        class="border d-flex justify-content-between avs-schema-modal-btn shadow" role="button"
                        (click)="AQonKanalSelectClicked()">
                        <div class="ms-1 p-1">{{AQselectedKanal ? AQselectedKanal.name : 'Kanal'}}</div>
                        <img *ngIf="!AQisKanalSelectOpen" class="me-2" src="assets/icons/caret-down.svg"
                            alt="caret-down open select">
                        <img *ngIf="AQisKanalSelectOpen" class="me-2" src="assets/icons/caret-up.svg"
                            alt="caret-up close select">
                    </div>
                    <avs-dropdown *ngIf="AQisKanalSelectOpen" class="position-absolute avs-schema-modal-btn"
                        [isHeaderActive]="false" [activeItem]="AQselectedKanal"
                        (onItemClicked)="AQonKanalSelectValueChange($event)" [selectInput]="AQkanalSelectInput"
                        [isSmallDropdown]="true">
                    </avs-dropdown>
                </div>
            </div>
            <div class="mb-2 d-flex justify-content-center" *ngIf="isBlinker">
            </div>
            <div class="m-2">
                <p class="text-center" [ngClass]="AQselectedKanal ? 'text-secondary' : 'text-danger'">
                    {{AQselectedKanal ? AQselectedKanal.name : 'Kein Kanal ausgewählt'}}
                </p>
            </div>
            <avs-bilderkatalog [images]="images" (myClick)="onSetImageForSetAqControl($event.stellcode)"
                [controlsStellcode]="AQManualControlsPreselectedCode"></avs-bilderkatalog>

            <avs-set-aq-control [dataEndChannels]="aqControlDataEndChannels"
                [selectedAQControlStellcode]="aqControlStellcode" [selectedKanalId]="selectedAqChannelId"
                [selectedAqChannel]="selectedAqChannel" [images]="images"></avs-set-aq-control>

        </div>
    </div>
    <!-- zu früh? -->


    <div *ngIf="flasherControlFound" class="border-top mt-3 ms-2 me-2">
        <div class="d-flex  mt-3">

            <span class="fw-semibold text-secondary ms-2">Steuerung Blinker </span>

            <span>
                <img *ngIf="!showFlasherControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-down.svg" alt="icon-delete-aq" (click)="onHideFlasherControlClick()"
                    matTooltip="Ausklappen" matTooltipPosition="right">
                <img *ngIf="showFlasherControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-up.svg" alt="icon-delete-aq" (click)="onHideFlasherControlClick()"
                    matTooltip="Einklappen" matTooltipPosition="right">
            </span>
            <span *ngIf="flasherControlActive"> <img src="assets/icons/back_hand_material.svg" height="24"></span>
        </div>
        <div *ngIf="flasherControlFound && showFlasherControl">
            <avs-set-flasher-control [dataEndChannels]="flasherControlDataEndChannels"
                [selectedKanalId]="selectedFlasherChannelId"
                [selectedAqChannel]="selectedFlasherChannel"></avs-set-flasher-control>
        </div>
    </div>

    <div *ngIf="barrierControlFound" class="border-top mt-3 ms-2 me-2">
        <div class="d-flex  mt-3">
            <span class="fw-semibold text-secondary ms-2">Steuerung Schranke </span>
            <span>
                <img *ngIf="!showBarrierControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-down.svg" alt="icon-delete-aq" (click)="onHideBarrierClick()"
                    matTooltip="Ausklappen" matTooltipPosition="right">
                <img *ngIf="showBarrierControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-up.svg" alt="icon-delete-aq" (click)="onHideBarrierClick()"
                    matTooltip="Einklappen" matTooltipPosition="right">
            </span>
        </div>

        <div *ngIf="showBarrierControl && barrierControlFound">
        <div *ngIf="barrierControlDataEndChannels.length > 1" class="mb-2 d-flex justify-content-center">
            <div>
                <div [ngClass]="BarrierIsChannelSelectOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between avs-schema-modal-btn shadow" role="button"
                    (click)="BarrierOnChannelSelectClicked()">
                    <div class="ms-1 p-1">{{BarrierSelectedChannel ? BarrierSelectedChannel.name : 'Kanal'}}</div>
                    <img *ngIf="!BarrierIsChannelSelectOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="BarrierIsChannelSelectOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown *ngIf="BarrierIsChannelSelectOpen" class="position-absolute avs-schema-modal-btn"
                    [isHeaderActive]="false" [activeItem]="BarrierSelectedChannel"
                    (onItemClicked)="BarrierOnChannelSelectValueChange($event)" [selectInput]="BarrierChannelSelectInput"
                    [isSmallDropdown]="true">
                </avs-dropdown>
            </div>
        </div>
            <avs-set-barrier-control [selectedBarrierChannel]="selectedBarrierChannel" [currentPositionCode]="BarrierCurrentPositionCode" [blocked]="BarrierBlocked">

            </avs-set-barrier-control>
        </div>
    </div>
    <div *ngIf="doControlFound" class="border-top mt-3 ms-2 me-2">

        <div class="d-flex  mt-3">
            <span class="fw-semibold text-secondary ms-2">Steuerung Ausgang </span>
            <span>
                <img *ngIf="!showDoControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-down.svg" alt="icon-delete-aq" (click)="onHideDOClick()"
                    matTooltip="Ausklappen" matTooltipPosition="right">
                <img *ngIf="showDoControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-up.svg" alt="icon-delete-aq" (click)="onHideDOClick()"
                    matTooltip="Einklappen" matTooltipPosition="right">
            </span>
            <div class="d-flex justify-content-between">
                <div>
                    <span *ngIf="doControlActive"> <img src="assets/icons/back_hand_material.svg" height="24"></span>
                </div>

            </div>
        </div>
    </div>

    <div *ngIf="showDoControl && doControlFound">
        <div class=" m-2">
            <p class="text-center" [ngClass]="DOselectedKanal ? 'text-secondary' : 'text-danger'">
                {{DOselectedKanal ? DOselectedKanal.name : 'Kein Kanal ausgewählt'}}
            </p>
        </div>
        <div class="mb-2 d-flex justify-content-center">
            <div>
                <div [ngClass]="DOisKanalSelectOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between avs-schema-modal-btn shadow" role="button"
                    (click)="DOonKanalSelectClicked()">
                    <div class="ms-1 p-1">{{DOselectedKanal ? DOselectedKanal.name : 'Kanal'}}</div>
                    <img *ngIf="!DOisKanalSelectOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="DOisKanalSelectOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown *ngIf="DOisKanalSelectOpen" class="position-absolute avs-schema-modal-btn"
                    [isHeaderActive]="false" [activeItem]="DOselectedKanal"
                    (onItemClicked)="DOonKanalSelectValueChange($event)" [selectInput]="DOkanalSelectInput"
                    [isSmallDropdown]="true">
                </avs-dropdown>
            </div>
        </div>
        <avs-set-do-control [selectedDoChannel]="selectedDoChannel"></avs-set-do-control>
    </div>



    <div *ngIf="diControlFound" class="border-top mt-3 ms-2 me-2">

        <div class="d-flex  mt-3">
            <span class="fw-semibold text-secondary ms-2">Steuerung Eingang </span>
            <span>
                <img *ngIf="!showDiControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-down.svg" alt="icon-delete-aq" (click)="onHideDIClick()"
                    matTooltip="Ausklappen" matTooltipPosition="right">
                <img *ngIf="showDiControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-up.svg" alt="icon-delete-aq" (click)="onHideDIClick()"
                    matTooltip="Einklappen" matTooltipPosition="right">
            </span>
            <div class="d-flex justify-content-between">
                <div>
                    <span *ngIf="diControlActive"> <img src="assets/icons/back_hand_material.svg" height="24"></span>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="showDiControl && diControlFound">
        <div class=" m-2">
            <p class="text-center" [ngClass]="DIselectedKanal ? 'text-secondary' : 'text-danger'">
                {{DIselectedKanal ? DIselectedKanal.name : 'Kein Kanal ausgewählt'}}
            </p>
        </div>
        <div class="mb-2 d-flex justify-content-center">
            <div>
                <div [ngClass]="DIisKanalSelectOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between avs-schema-modal-btn shadow" role="button"
                    (click)="DIonKanalSelectClicked()">
                    <div class="ms-1 p-1">{{DIselectedKanal ? DIselectedKanal.name : 'Kanal'}}</div>
                    <img *ngIf="!DIisKanalSelectOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="DIisKanalSelectOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown *ngIf="DIisKanalSelectOpen" class="position-absolute avs-schema-modal-btn"
                    [isHeaderActive]="false" [activeItem]="DIselectedKanal"
                    (onItemClicked)="DIonKanalSelectValueChange($event)" [selectInput]="DIkanalSelectInput"
                    [isSmallDropdown]="true">
                </avs-dropdown>
            </div>
        </div>

        <avs-set-di-control [selectedDiChannel]="selectedDiChannel"></avs-set-di-control>

    </div>



    <div *ngIf="mqControlFound" class="border-top mt-3 ms-2 me-2">
        <div class="d-flex  mt-3">
            <span class="fw-semibold text-secondary ms-2"> Steuerung MQ</span>
            <span>
                <img *ngIf="!showMqControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-down.svg" alt="icon-delete-aq" (click)="onHideMQClick()"
                    matTooltip="Ausklappen" matTooltipPosition="right">
                <img *ngIf="showMqControl" style="height: 26px;" class="avs-icon-delete p-1"
                    src="assets/icons/caret-up.svg" alt="icon-delete-aq" (click)="onHideMQClick()"
                    matTooltip="Einklappen" matTooltipPosition="right">
            </span>
                <span *ngIf="mqControlActive" [matTooltip]="activeMQs()"> <img src="assets/icons/back_hand_material.svg" height="24"></span>
        </div>
    </div>

    <div *ngIf="showMqControl && mqControlFound">
        <div class="m-2">
            <p class="text-center" [ngClass]="MQselectedKanal ? 'text-secondary' : 'text-danger'">
                {{MQselectedKanal ? MQselectedKanal.name : 'Kein Kanal ausgewählt'}}
            </p>
        </div>
        <div>
            <div class="mb-2 d-flex justify-content-center">
                <div>
                    <div [ngClass]="MQisKanalSelectOpen ? 'border-danger' : ''"
                        class="border d-flex justify-content-between avs-schema-modal-btn shadow" role="button"
                        (click)="MQonKanalSelectClicked()">
                        <div class="ms-1 p-1">{{MQselectedKanal ? MQselectedKanal.name : 'Kanal'}}</div>
                        <img *ngIf="!MQisKanalSelectOpen" class="me-2" src="assets/icons/caret-down.svg"
                            alt="caret-down open select">
                        <img *ngIf="MQisKanalSelectOpen" class="me-2" src="assets/icons/caret-up.svg"
                            alt="caret-up close select">
                    </div>
                    <avs-dropdown *ngIf="MQisKanalSelectOpen" class="position-absolute avs-schema-modal-btn"
                        [isHeaderActive]="false" [activeItem]="MQselectedKanal"
                        (onItemClicked)="MQonKanalSelectValueChange($event)" [selectInput]="MQkanalSelectInput"
                        [isSmallDropdown]="true">
                    </avs-dropdown>
                </div>
            </div>
            <avs-set-mq-control [selectedMqChannel]="selectedMqChannel"></avs-set-mq-control>
        </div>


    </div>
</div>